/*
* @描述: 开票详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/13 20:50
*/
<template>
    <van-popup v-model.sync="dialogVisible"
               :style="{ width: '100%',height: '100%' }">
        <div v-loading="loading" class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              title="返回"
                              @returnEvent="handleDialogClose"></ReturnNavBar>
            </div>
            <div class="detail_wrap_container">
                <div class="m_page_little_title">
                    <span class="title">订单信息</span>
                </div>
                <div class="detail_chunk_wrap">
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">关联订单</div>
                        <div class="form_item_value" v-text="orderInfo.order_no"></div>
                    </div>
                    <div class="m_detail_form_item">
                        <div class="form_item_label">客户联系人</div>
                        <div v-if="orderInfo.contact_info" class="form_item_value"
                             v-text="orderInfo.contact_info.name"></div>
                    </div>
                </div>
                <div class="m_page_little_title">
                    <span class="title">订单金额信息</span>
                </div>
                <div class="detail_chunk_wrap">
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">订单总金额</div>
                        <div class="form_item_value" v-text="orderInfo.total_price"></div>
                    </div>
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">已回款金额</div>
                        <div class="form_item_value" v-text="orderInfo.total_repay_price"></div>
                    </div>
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">待回款金额</div>
                        <div class="form_item_value" v-text="orderInfo.no_repay_price"></div>
                    </div>
                    <div class="m_detail_form_item">
                        <div class="form_item_label">实际回款金额</div>
                        <div class="form_item_value" v-text="orderInfo.repay_price"></div>
                    </div>
                </div>
                <div class="m_page_little_title">
                    <span class="title">开票申请信息</span>
                </div>
                <div class="detail_chunk_wrap">
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">开票公司</div>
                        <div class="form_item_value" v-text="invoiceInfo.invoice_company_name"></div>
                    </div>
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">发票类型</div>
                        <div class="form_item_value" v-text="invoiceInfo.invoice_type_name"></div>
                    </div>
                    <div v-if="invoiceInfo.invoice_type===1||invoiceInfo.invoice_type===2" class="m_detail_form_item mb_8">
                        <div class="form_item_label">电子发票提供方式</div>
                        <div class="form_item_value" v-text="invoiceInfo.invoice_method_name"></div>
                    </div>
                    <div v-if="invoiceInfo.invoice_type===1||invoiceInfo.invoice_type===2" class="m_detail_form_item mb_8">
                        <div class="form_item_label">电子收票邮箱</div>
                        <div class="form_item_value" v-text="invoiceInfo.invoice_email"></div>
                    </div>
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">本次开票金额</div>
                        <div class="form_item_value" v-text="invoiceInfo.invoice_amount"></div>
                    </div>
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">开票对象</div>
                        <div class="form_item_value" v-text="invoiceInfo.invoice_title_type_name"></div>
                    </div>
                    <div class="m_detail_form_item mb_8">
                        <div class="form_item_label">本次开票金额</div>
                        <div class="form_item_value" v-text="invoiceInfo.invoice_amount"></div>
                    </div>
                    <div class="m_detail_form_item flex_vertical mb_8">
                        <div class="form_item_label">开票信息</div>
                        <div class="form_item_value" v-text="invoiceInfo.invoice_info"></div>
                    </div>
                    <div v-if="invoiceInfo.invoice_type===3||invoiceInfo.invoice_type===4" class="m_detail_form_item mb_8">
                        <div class="form_item_label">收货人</div>
                        <div class="form_item_value" v-text="invoiceInfo.receive_name?invoiceInfo.receive_name:'--'"></div>
                    </div>
                    <div v-if="invoiceInfo.invoice_type===3||invoiceInfo.invoice_type===4" class="m_detail_form_item mb_8">
                        <div class="form_item_label">收货人电话</div>
                        <div class="form_item_value"
                             v-text="invoiceInfo.receive_phone?invoiceInfo.receive_phone:'--'"></div>
                    </div>
                    <div v-if="invoiceInfo.invoice_type===3||invoiceInfo.invoice_type===4" class="m_detail_form_item mb_8">
                        <div class="form_item_label">收货地址</div>
                        <div class="form_item_value" v-text="invoiceInfo.receive_addr?invoiceInfo.receive_addr:'--'"></div>
                    </div>
                    <div class="m_detail_form_item flex_vertical mb_8">
                        <div class="form_item_label">备注</div>
                        <div class="form_item_value" v-text="invoiceInfo.remark?invoiceInfo.remark:'--'"></div>
                    </div>
                    <div class="m_detail_form_item flex_vertical">
                        <div class="form_item_label">附件</div>
                        <div class="form_item_value">
                            <ul v-if="invoiceInfo.attachments&&invoiceInfo.attachments.length" class="upload_file_list">
                                <li v-for="(file,file_idx) in invoiceInfo.attachments"
                                    class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="下载"
                                                    effect="dark"
                                                    placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                  @click="handleClickDownloadFile(file)">
                                                <i class="iconfont icon-daochu"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                            </ul>
                            <div v-else>--</div>
                        </div>
                    </div>
                </div>
            </div>
            <el-image ref="preview_img"
                      :preview-src-list="previewImgList"
                      :src="previewImgSrc"
                      style="display:none">
            </el-image>
        </div>
    </van-popup>
</template>
<script>
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import {InvoiceDetail} from "@/api";
import {getOSSData} from "@/utils/uploadOss";

export default {
    name: "InvoiceDetail",
    data() {
        return {
            loading: false,
            invoiceInfo: {},
            orderInfo: {},
            previewImgList: [],
            previewImgSrc: '',
            defaultImg: require('@/assets/images/default.jpg'),
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        invoice_no: {
            type: String,
            default: '',
        },
    },
    components: {
        ReturnNavBar,
    },
    created() {
        this.getInvoiceDetail()
    },
    mounted() {

    },
    methods: {
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
            this.$emit('update:invoice_no', '')
        },

        // 详情
        getInvoiceDetail() {
            this.loading = true;
            InvoiceDetail({invoice_no: this.invoice_no}).then((res) => {
                if (res.code === 200) {
                    this.invoiceInfo = res.data.invoice_info;
                    this.orderInfo = res.data.order_info;
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            });
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不允许预览，请下载后查看')
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
    },
}
</script>
<style lang="scss" scoped>

</style>